<template>
  <div>
    <el-form label-position="right">
      <title-and-description :field="field" />
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="form-group">
            <Tag :field="field" />
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item>
            <label
              class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal !block !w-full !mb-1"
            >
              Field Options
              <span class="text-red-500">*</span>
            </label>
            <el-select
              placeholder="Enter options"
              v-model="field.options"
              :clearable="true"
              :allow-create="true"
              :default-first-option="true"
              :filterable="true"
              :multiple="true"
              :no-data-text="''"
            >
              <el-option
                v-for="(opt, index) of field.options"
                :key="index"
                :label="opt"
                :value="opt"
              ></el-option>
            </el-select>
            <i class="el-icon-edit" @click="openOptions" style="margin-left: 5px"></i>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <dialog-component
      :visible="optionsDialogVisible"
      :title="'Edit options'"
      @before-close="optionsDialogVisibleClose"
      :containerWidth="getIsMobile ? '100%' : '35%'"
      :containerMinHeight="'55%'"
      center
    >
      <!-- <div class="tableScroll"> -->
      <el-table
        border
        height="350"
        :data="field.options"
        @cell-mouse-enter="editoptionsData"
        @cell-mouse-leave="resetoptionsData"
      >
        <el-table-column label="Options">
          <template slot-scope="scope">
            <div v-if="currentActiveRowIndex == scope.$index">
              <el-input size="mini" v-model="field.options[scope.$index]"></el-input>
            </div>
            <div v-else>
              <p style="font-size: 14px" slot="reference">
                {{ scope.row }}
              </p>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- </div> -->
      <el-collapse>
        <el-collapse-item>
          <template slot="title">Drag fields to change the column order</template>
          <div>
            <el-scrollbar class="elementsScroll">
              <table
                class="table table-striped"
                style="z-index: 1000; border: 10px; margin: 5px 0px"
              >
                <tr>
                  <draggable v-model="field.options" tag="tr">
                    <th v-for="(column, index) in field.options" :key="index">
                      <el-tag type="info">{{ column }}</el-tag>
                    </th>
                  </draggable>
                </tr>
              </table>
            </el-scrollbar>
          </div>
        </el-collapse-item>
      </el-collapse>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveData">Save</el-button>
      </span>
    </dialog-component>
  </div>
</template>

<script>
  import TitleAndDescription from './TitleAndDescription';
  // import Placeholder from "./Placeholder";
  import Tag from './Tag';
  import { mapGetters } from 'vuex';
  import draggable from 'vuedraggable';

  export default {
    components: {
      TitleAndDescription,
      Tag,
      draggable,
      // Placeholder
    },
    props: ['field'],
    data() {
      return {
        validations: [],
        rowsOptions: [
          {
            title: 'Folder 1',
            _id: '1',
          },
          {
            title: 'Folder 2',
            _id: '2',
          },
          {
            title: 'Folder 3',
            _id: '3',
          },
        ],
        options: [],
        inputVisible: false,
        inputValue: '',
        dialogOptions: [],
        currentActiveRowIndex: -1,
        newOption: '',
        optionsDialogVisible: false,
      };
    },
    computed: {
      ...mapGetters('navigationOpen', ['getIsMobile']),
    },
    methods: {
      optionsDialogVisibleClose() {
        this.optionsDialogVisible = false;
      },
      openOptions() {
        if (this.isView) {
          return;
        }
        this.optionsDialogVisible = true;
      },
      saveData() {
        this.dialogOptions = [...this.field.options];
        this.field.options = [...this.field.options];
        this.optionsDialogVisible = false;
      },
      handleInputConfirm() {
        let inputValue = this.inputValue.trim();
        let inpuValues = inputValue.split(',');

        if (inpuValues.length) {
          inpuValues.forEach((value) => {
            value = value.trim();
            if (value.length) {
              let existed = this.field.options.find((value1) => value1 == value);
              if (!existed) {
                this.field.options.push(value);
              }
            }
          });
        }
        this.inputVisible = false;
        this.inputValue = '';
      },
      showInput() {
        this.inputVisible = true;
        this.$nextTick(() => {
          this.$refs.saveTagInput.focus();
        });
      },
      handleClose(tagValue) {
        let accessionIdIndex = this.field.options.findIndex((x) => x == tagValue);
        this.field.options.splice(accessionIdIndex, 1);
      },
      editoptionsData(row) {
        this.currentActiveRowIndex = this.field.options.indexOf(row);
      },
      resetoptionsData() {
        const uniqueOptions = [...new Set(this.field.options)];
        if (this.field.options.length < this.field.options.length) {
          this.dialogOptions = uniqueOptions;
        }
        this.field.options = [...this.field.options];
        this.field.options = this.field.options.filter(function (element) {
          return element !== '';
        });
        this.currentActiveRowIndex = -1;
      },
    },
    watch: {
      optionsDialogVisible(newVal) {
        if (newVal) {
          this.dialogOptions = this.field.options.slice();
        }
      },
    },
  };
</script>

<style lang="scss"></style>
